// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5e655eb0","455":"1b991356","977":"fb9740ee"}[chunkId] + ".chunk.js";
};